export const transformServerToFormErrors = (
  errors: Record<string, string>,
  formFieldsMap?: Record<string, string>,
) =>
  Object.entries(errors).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [formFieldsMap?.[key] ?? key]: { message: value },
    }),
    {},
  );
